export default __webpack_public_path__ + "static/media/BG-2.3790df58.webp";